import { Component, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService, SuppliersService, DocumentsService, ContactsService } from '../../../all-services';
import { Address, Currency, SimpleReponseResult, SupplierAccountParameters, SaveStepParam, PafDocument } from '../../../all-models';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SupplierDetailsStepBase, checkValidityEvent } from '../supplier-details/suppliers-details-step-base';
import { saveAs } from '@progress/kendo-file-saver';


@Component({
  selector: 'app-supplier-account-info',
  templateUrl: './supplier-account-info.component.html',
  styleUrls: ['./supplier-account-info.component.scss']
})
export class SupplierAccountInfoComponent extends SupplierDetailsStepBase implements OnChanges {

  frBtnImagePath: string = './assets/images/FRBtn.png';
  enBtnImagePath: string = './assets/images/ENBtn.png';
  infosDemat: string = '';
  @ViewChild('frmAccount') frmAccount: NgForm;

  get TopAffacturage(): boolean {
    return this.supplier.TopAffacturage == 1;
  }
  set TopAffacturage(value: boolean) {
    this.supplier.TopAffacturage = (value ? 1 : 0);
  }

  public infoDematWindowSettings: any = {
    visible: false,
    minWidth: 800,
    minHeight: 600,
    top: 10,
    left: 10,
    resizable: false,
    state: 'default'
  }
  showHideinfoDematWindow(value: boolean): void {
    this.infoDematWindowSettings.visible = value;
  }

  public get TopAddrFac(): boolean {
    return this.supplier.AddrFacId != null;
  }
  public set TopAddrFac(value: boolean) {
    if (!value) {
      this.supplier.AddrFacId = null;
    } else {
      if (this.supplier.FacAddress != null) {
        this.supplier.AddrFacId = this.supplier.FacAddress.Id;
      } else {
        this.supplier.FacAddress = new Address();
        this.supplier.AddrFacId = 0;
      }
    }
  }

  get TopFacDemat(): boolean {
    return this.supplier.TopFacDemat == 1;
  }
  set TopFacDemat(value: boolean) {
    this.supplier.TopFacDemat = (value ? 1 : 0);
  }
  get lblTopAffacturage(): Observable<string> {
    return this.Label('Travaillez_vous_avec_une_societe_d_affacturage');
  }
  get lblTopAddrFac(): Observable<string> {
    return this.Label('Avez_vous_une_addresse_de_facturation_differente');
  }
  get lblTopFacDemat(): Observable<string> {
    return this.Label('Souhaitez_vous_la_dematerialisation_des_factures');
  }

  constructor(
    public sharedDatasSvc: SharedDataService,
    public suppliersSvc: SuppliersService,
    public docsSvc: DocumentsService,
    public route: ActivatedRoute,
    private http: HttpClient,
    public contactsSvc: ContactsService) {
    super(sharedDatasSvc, docsSvc, suppliersSvc, route, contactsSvc);
  }


  ngOnInit(): void {
    if (this.sharedDatasSvc.allListsLoaded) {
      this.subscriptions.push(this.sharedDatasSvc.allListsLoadedChange.subscribe(() => this.initOnglet()));
    } else {
      this.initOnglet();
    }
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }


  initOnglet() {
    if (!this.supplier.OrderCurId) {
      this.supplier.OrderCurrency = this.sharedDatasSvc.currencies.find(c => c.Cod == 'EUR');
      this.supplier.OrderCurId = this.supplier.OrderCurrency.Id;
    }
  }

  private _ShowSaveButton = (): any => {
    if (this.isCreatingSupplier) return true;
    return !(this.infoComptableOthersDisabled) || !(this.infoComptableDematDisabled);
  }

  public get infoComptableOthersDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    if (!this.sharedDatasSvc.profil?.Cod) return true;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('ACCOUNT_INFO');
  }

  public get infoComptableDematDisabled(): boolean {
    if (!this.infoComptableOthersDisabled) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('ACCOUNT_INFO_DEMAT');
  }

  onCheckValidity(event: checkValidityEvent): Observable<boolean | undefined> {
    if (event.stepNum != this.screenValidity.step) return of(undefined);
    event.forms = [this.frmAccount];
    return of(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['ocurrentstep']) {
      setTimeout(() => {
        this.ocurrentstep.showSaveButton = (): boolean => { return this._ShowSaveButton() };
      }, 0);
    }
  }

  save(param: SaveStepParam): void {
    if (param.nextAction == 'forceScreen') {
      super.save(param);
      return;
    }
    this.CanSave(this.frmAccount, param);

    let parameters: SupplierAccountParameters = new SupplierAccountParameters();
    Object.keys(parameters).forEach((key, index) => {
      (<any>parameters)[key] = (<any>this.supplier)[key];
    });
    if (parameters.OrderCurrency && parameters.OrderCurrency?.Id != parameters.OrderCurId) {
      parameters.OrderCurId = parameters.OrderCurrency.Id;
      delete parameters.OrderCurrency;
    }
    parameters.PayCurId = parameters.OrderCurId;
    if (parameters.PayCurrency) delete parameters.PayCurrency;
    if (param.nextAction == 'next') parameters.RefStep++;
    if (param.nextAction == 'previous') parameters.RefStep--;
    if (!param.canSave) {
      if (param.noSaveAllowed(this.currentStep)) {
        this.msgEcranIncomplet.subscribe(msg => {
          this.sharedDatasSvc.confirm(msg,
            (): void => {
              super.save(param);
            }, null);
        });
      }
      return;
    }
    this.suppliersSvc.patchSupplierAccount(this.supplier.Id, parameters)
      .subscribe((res: SimpleReponseResult) => {
        if (res.Ok) {
          super.save(param);
        } else {
          this.sharedDatasSvc.alert(res.Message);
        }
      });
  }

  showHideInfoDemat(visible: boolean): void {
    this.infoDematWindowSettings.visible = visible;
  }

  get showConditionsFileLink(): boolean {
    if (!this.supplier) return false;
    return this.supplier.TopFacDemat == 1
      && !!this.supplier.FacSendEmail
      && !!this.supplier.FacReturnEmail
      && !!this.supplier.PaySendEmail;
  }

  btnDownloadConditionsFile(): void {
    this.docsSvc.getPafDocuments()
      .subscribe((pds: PafDocument[]) => {
        let docDemat = pds.find(d => d.Cod == 'CONDITIONS_DEMAT');
        if (!docDemat) {
          this.sharedDatasSvc.alert(`Le modèle ayant pour code 'CONDITIONS_DEMAT' est introuvable en base.`);
          return;
        }
        this.docsSvc.downloadTemplate(docDemat.Id, this.supplier.Id)
          .subscribe(blob => {
            saveAs(blob, docDemat.TemplatePath);
          });
      });
  }

  currencyDisplay(item:Currency): string {
    if (!item) return"";
    return `${item.Cod} - ${item.LblCod}`;
  }

}
